module.exports = __webpack_public_path__ + "static/media/209-Patientenakte_ID_11.2105ece0.mp3";